import * as Dialog from '@ewf/components/Dialog';
import { TransactionProgress } from '../ModalUI/TransactionProgress';
import { SunkenBox } from '../SunkenBox';
import { ProgressBadgeEWX } from '../StatusBadge/ProgressBadge';
import { TxSuccess } from '../TxSuccess';
import { TxFailure } from '../TxFailure';

type Step =
  | 'confirm'
  | 'success'
  | 'failure';

export const PromptKYCSignature = ({
    isOpen,
    onClose,
    step,
    kycFailureMessage,
  }: Props): React.ReactNode => {
    const stepComponents: Record<Step, React.ReactNode> = {
      confirm: (
        <div className="w-[550px] rounded-lg border-2 border-transparent p-8 gradient-border-secondary-with-gray-90">
          <section className="mb-8 rounded-lg p-6 bg-popup-gradient">
            <TransactionProgress operation="kyc-signature" step="confirm" />
            <SunkenBox className="mb-6 text-center">
              <p className="mb-2 font-bold">Sign request</p>
              <span className="text-font-subtler">Please review and sign this request in your wallet</span>
            </SunkenBox>
            <SunkenBox className="mt-8 grid place-items-center p-8">
              <ProgressBadgeEWX />
            </SunkenBox>
          </section>
        </div>
      ),
      success: (
        <TxSuccess
          title="The KYC form has opened in your browser. Please fill in your details to finish verification."
          buttonLabel="Close"
          operation="kyc-signature"
          onNext={onClose}
          onClose={onClose}
        />
      ),
      failure: (
        <TxFailure title="Sign request failed" operation="kyc-signature" onClose={onClose} message={kycFailureMessage || 'Failed to sign request'} />
      ),
    };
    return (
      <Dialog.Root open={isOpen}>
        <Dialog.Portal>
          <Dialog.Overlay>
            <Dialog.Content forceMount>
              {stepComponents[step]}
            </Dialog.Content>
          </Dialog.Overlay>
        </Dialog.Portal>
      </Dialog.Root>
    );
};

interface Props {
  isOpen: boolean;
  onClose: () => void;
  step: Step;
  kycFailureMessage?: string;
}